module.exports = "/assets/kropla.png?E6uo0Ks";